import styled from 'styled-components';
import { Translate } from 'react-redux-i18n';

import { StyleColor } from '../../../../utils/styles-constants';
import { hexToRgba } from '../../../../utils/style';
import { PopupTheme } from '../../../Popup';

interface MessageProps {
	theme: PopupTheme;
}

const PopupBody = styled('div')`
	padding: 10px 15px;
`;

const Message = styled(Translate)`
	display: block;
	margin-bottom: 10px;

	${({ theme }: MessageProps) => theme === PopupTheme.DARK && `
		color: ${hexToRgba(StyleColor.White, 75)};
	`}
`;

export {
	PopupBody,
	Message,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Share/UprezForm/ShareViaCopyPopup/styles.ts